export default {
      id: "community-outline-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#community-outline",
      toString: function () {
        return this.url;
      }
    }